import { render } from "./IconChevronFirst.vue?vue&type=template&id=60ee84c0"
import script from "./IconChevronFirst.vue?vue&type=script&lang=js"
export * from "./IconChevronFirst.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__